// Related functions on menu component
import { isMobile, isDesktop, isTemplateEnv } from '../common/_constants'
import { monitorForChanges, waitForElmBySelectorIndex } from '../components/helpers/_observer-handler'

// Primary Menu Function
export const primaryNavHandler = () => {
    let primaryNavInit
    let primaryMenuMoreItems = document.querySelector('.primary-menu-wrapper > .menu > .more')

    const subMenuItems = moreItemsContainer()

    const mainMenuBlock = document.querySelector('#block-tsn-main-menu')
    const primaryMenuWrapper = document.querySelector('.primary-menu-wrapper')
    const primaryMenuContainer = document.querySelector('.primary-menu-wrapper > .menu')
    const primaryMenuItems = document.querySelectorAll('.primary-menu-wrapper > .menu > .menu-item:not(.more)')
    const moreItemsSubMenu = document.querySelector('.primary-menu-wrapper > .menu > .more > .more-submenu')
    const moreItemsChildren = document.querySelectorAll(
        '.primary-menu-wrapper > .menu > .more > .more-submenu > .menu-item'
    )

    if (((primaryMenuWrapper && !primaryNavInit) || (mainMenuBlock && !primaryNavInit)) && isDesktop()) {
        let navWidth = 0
        const availableSpace = 625
        if (!primaryMenuMoreItems) {
            primaryMenuContainer.append(subMenuItems)
        }

        for (const primaryMenuItem of primaryMenuItems) {
            navWidth += primaryMenuItem.offsetWidth * 1.5
        }

        if (navWidth > availableSpace) {
            const primaryMenuLastItem = primaryMenuItems[primaryMenuItems.length - 1]

            primaryMenuLastItem.dataset.width = primaryMenuLastItem.offsetWidth

            jQuery('.primary-menu-wrapper > .menu > li:not(.more)').last().prependTo(moreItemsSubMenu)

            primaryMenuMoreItems = document.querySelector('.primary-menu-wrapper > .menu > .more')
            primaryMenuMoreItems.classList.add('has-items')

            primaryNavHandler()
        }

        primaryNavInit = true

        const primaryMenuAllItems = document.querySelectorAll('.primary-menu-wrapper > .menu > .menu-item')
        primaryMenuAllItems.forEach(item => {
            item.classList.add('visible')
        });
    } else {
        for (const item of moreItemsChildren) {
            primaryMenuContainer.append(item)
        }

        if (primaryMenuMoreItems) primaryMenuMoreItems.remove()
    }
}

// Enable scrolls of side navigation (mobile)
export const getHeightSideNav = () => {
    const sideNav = document.querySelector('.tsn-primary-menu__top .tsn-primary-menu__container .primary-menu-wrapper')
    const additionalMenuWrapper = document.querySelector('.additional-menu-wrapper')
    const topAdvert = document.querySelector('#ad-topBanner1')
    const primaryMenuTop = document.querySelector('.tsn-primary-menu__top')
    const additionalMenuHeader = document.querySelector('.additional-header--menu')
    const withGlobalMenu = document.querySelector('.widget-global-navigation')

    if (isMobile()) {
        const additionalMenuHeight = additionalMenuHeader ? additionalMenuHeader.offsetHeight : 0
        let topContainerHeight = topAdvert.offsetHeight + primaryMenuTop.offsetHeight
        let sideNavHeight = `${window.innerHeight - topContainerHeight - additionalMenuHeight}px`

        sideNav.style.height = sideNavHeight
        additionalMenuWrapper.style.top = sideNavHeight

        monitorForChanges('#ad-topBanner1', () => {
            topContainerHeight = topAdvert.offsetHeight + primaryMenuTop.offsetHeight
            sideNavHeight = `${window.innerHeight - topContainerHeight - additionalMenuHeight}px`

            additionalMenuWrapper.style.top = sideNavHeight
            sideNav.style.height = sideNavHeight
        })

        if (withGlobalMenu) {
            let globalMenuHeight = withGlobalMenu.offsetHeight
            let sideNavHeight = `${window.innerHeight - topContainerHeight - additionalMenuHeight - globalMenuHeight}px`

            sideNav.style.height = sideNavHeight
            additionalMenuWrapper.style.top = sideNavHeight
        }
    } else {
        sideNav.style.height = 'unset'
        additionalMenuWrapper.style.top = 'unset'
        monitorForChanges('#ad-topBanner1', () => {
            sideNav.style.height = 'unset'
            additionalMenuWrapper.style.top = 'unset'
        })
    }
}

// Mobile navigation toggle
export const mobileMenuButtonHandler = () => {
    const mobileMenuBtn = document.querySelector('.tsn-primary-menu__container > .mobile-menu-btn')
    const additionalMenuWrapper = document.querySelector('.additional-menu-wrapper')
    const bodyContainer = document.querySelector('html body')

    const mobileBtnHandler = () => {
        mobileMenuBtn.classList.toggle('active')
        mobileMenuBtn.classList.contains('active')
            ? (bodyContainer.style.overflow = 'hidden')
            : (bodyContainer.style.overflow = 'auto')
        bodyContainer.classList.toggle('overlay')
        if (additionalMenuWrapper) {
            additionalMenuWrapper.classList.toggle('active')
        }
    }

    jQuery('.mobile-menu-btn').unbind('click').click(mobileBtnHandler)

    if (isDesktop() && mobileMenuBtn.classList.contains('active')) {
        mobileMenuBtn.classList.remove('active')
        bodyContainer.classList.remove('overlay')
        additionalMenuWrapper.classList.remove('active')
        bodyContainer.style.overflow = 'auto'
    }
}

// Prepare second level menu (mobile)
export const mobileMenuArrowHAndler = () => {
    const hasChildItemNba = document.querySelector(
        '.primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu'
    )
    const hasChildItems = document.querySelectorAll('.primary-menu-wrapper > .menu > .menu-item > .menu')
    const thirdLevelMenuItems = document.querySelectorAll('.menu-item.has-children .menu-item > .menu')


    if (hasChildItemNba) {
        hasChildItemNba.closest('.menu-item').classList.add('has-children')
        hasChildItemNba.closest('.menu-item').append(childrenArrowContainer())
    }

    for (const thirdLevelMenuItem of thirdLevelMenuItems) {
        thirdLevelMenuItem.closest('.menu-item').classList.add('has-children__second-level')
        thirdLevelMenuItem.closest('.menu-item').append(childrenSecondArrowContainer())
    }

    const menuArrows = document.querySelectorAll('.primary-menu-wrapper > .menu .has-children > i')

    if (menuArrows) {
        for (const menuArrow of menuArrows) {
            menuArrow.addEventListener('click', (event) => {
                event.preventDefault()
                menuArrow.closest('.has-children').classList.toggle('is-open-mobile')
            })
        }
    }

    if (menuArrows && isDesktop()) {
        for (const menuArrow of menuArrows) {
            menuArrow.closest('.has-children').classList.remove('is-open-mobile')
            menuArrow.remove()
        }
    }
}

// Handles third level menu toogle and classnames
export const thirdLevelMenuHandler = () => {
    const thirdLevelItems = jQuery('.has-children-second__arrow')
    const arrayItem = []
    thirdLevelItems.each((index, thirdLevelItem) => {
        arrayItem.push(thirdLevelItem)
        jQuery(thirdLevelItem).click(function (event) {
            event.preventDefault()
            jQuery(this).closest('.has-children__second-level').toggleClass('second-level-is-open-mobile')
            if (jQuery(this).parent().hasClass('second-level-is-open-mobile')) {
                jQuery(this).prev().css('display', 'block').addClass('third-level-item')
                if (jQuery(this).closest('.is-open-mobile').children('.third-level-item').length > 0) {
                    jQuery(this).closest('.is-open-mobile').children('.has-children__arrow').nextAll().remove()
                }

                jQuery(this).prev().clone().appendTo(jQuery(this).closest('.is-open-mobile'))
                jQuery(this).prev().hide()
            } else {
                jQuery(this).closest('.is-open-mobile').children('.has-children__arrow').nextAll().remove()
                jQuery(this).prev().css('display', 'block')
            }

            for (const itemFromList of arrayItem) {
                if (
                    itemFromList !== thirdLevelItem &&
                    jQuery(itemFromList).parent().hasClass('second-level-is-open-mobile')
                ) {
                    jQuery(itemFromList).parent().removeClass('second-level-is-open-mobile')
                }
            }
        })
    })
}

// Handles second level menu toogle and highlights
export const primaryNavSubItemsHandler = () => {
    const currentURL = window.location

    const activePrimaryMenu = document.querySelector('.primary-menu-wrapper > .menu .menu-item--active-trail')
    const activeAdditionalMenu = document.querySelector('.additional-menu-wrapper > .additional-header--menu > .menu-item--active-trail')
    const bottomPrimaryMenu = document.querySelector('.tsn-primary-menu__bottom')
    const bottomPrimaryMenuDisplay = document.querySelector('.tsn-primary-menu__bottom.is-secondary > *')
    const activePrimarySubMenu = document.querySelector(
        '.primary-menu-wrapper > .menu > .menu-item--active-trail .menu'
    )
    const activeAdditionalSubMenu = document.querySelector('.additional-menu-wrapper > .additional-header--menu > .menu-item .menu')
    const headerContainer = document.querySelector('header')
    const isNbaSibPage = document.querySelectorAll('.primary-menu-wrapper .nba-menu-wrapper .branded-secondary-nav-buttons').length > 0

    if (activePrimaryMenu && !isNbaSibPage && isMobile()) {
        bottomPrimaryMenu.classList.add('is-secondary')

        if (!bottomPrimaryMenuDisplay && activePrimarySubMenu) {
            bottomPrimaryMenu.append(activePrimarySubMenu.cloneNode(true))
        }

        headerContainer.classList.add('secondary-margin')
    } else if (activeAdditionalMenu && isMobile()) {
        bottomPrimaryMenu.classList.add('is-secondary')

        if (!bottomPrimaryMenuDisplay && activeAdditionalSubMenu) {
            bottomPrimaryMenu.append(activeAdditionalSubMenu.cloneNode(true))
        }

        headerContainer.classList.add('secondary-margin')
    } else {
        const bottomPrimaryMenuChild = bottomPrimaryMenu.querySelector('.menu')

        bottomPrimaryMenu.classList.remove('secondary-margin')

        if (bottomPrimaryMenuChild) {
            bottomPrimaryMenu.querySelector('.menu').remove()
        }
    }

    const secondaryItems = document.querySelectorAll('.tsn-primary-menu__bottom > .menu > .menu-item')

    for (const secondaryItem of secondaryItems) {
        const anchorTag = secondaryItem.querySelector('a')
        if (anchorTag.href === currentURL.href) {
            secondaryItem.classList.add('menu-item--active-trail')
        }
    }
}

// Handles sticky behaviour of navigation
export const stickNavHandler = () => {
    const primaryNavigation = document.querySelector('.tsn-primary-menu')
    const primaryTopNavigation = document.querySelector('.tsn-primary-menu__top')
    const primaryBottomNavigation = document.querySelector('.tsn-primary-menu__bottom')
    const regionHeader = document.querySelector('.region-header')
    const adSticky = document.querySelector('.topBanner-sticky')
    const navToRegionHeight = 111
    const subnavElement = document.querySelector('.menu-item--active-trail ul.menu')
    const stickyMPU = document.querySelector('.ad-stickyMPU-sticky')
    const adTopBanner1 = document.querySelector('#ad-topBanner1')

    let adTopBannerHeight = 0
    let timeout = false
    const delay = 10
    let subnavtoRegionHeight = 161

    if (adTopBanner1) {
        monitorForChanges('#ad-topBanner1', () => {
            if (isMobile()) {
                primaryNavigation.style.top = `${adSticky.clientHeight}px`
            } else {
                adTopBannerHeight = adSticky.clientHeight
                if (adTopBannerHeight > 105) {
                    subnavtoRegionHeight = 310
                }
            }
        })
    }

    if (isDesktop()) {
        window.addEventListener('scroll', () => {
            clearTimeout(timeout)

            timeout = setTimeout(() => {
                const documentScrolledValue = document.documentElement.scrollTop

                if (documentScrolledValue > adTopBannerHeight + navToRegionHeight) {
                    primaryTopNavigation.classList.add('tsn-primary-menu__fixed')
                    regionHeader.style.marginBottom = '50px'
                    if (subnavElement) {
                        primaryBottomNavigation.classList.add('tsn-primary-menu__fixed')
                        regionHeader.style.marginBottom = '100px'
                    }
                }

                if (documentScrolledValue < subnavtoRegionHeight) {
                    primaryTopNavigation.classList.remove('tsn-primary-menu__fixed')
                    regionHeader.style.marginBottom = 0
                    if (subnavElement) {
                        primaryBottomNavigation.classList.remove('tsn-primary-menu__fixed')
                        regionHeader.style.marginBottom = 0
                    }
                }

                if (stickyMPU && subnavElement) {
                    stickyMPU.classList.add('adjusted-top')
                }
            }, delay)
        })
    }
}

// Handles toggle of more items button (...)
export const moreItemsToggleHandler = () => {
    const moreItemsButton = document.querySelector('.primary-menu-wrapper > .menu > .more.has-items')
    const moreItemsButtonNBA = document.querySelector('.primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu > .more-second.has-items')

    if (isDesktop()) {
        if (moreItemsButton) {
            moreItemsButton.removeEventListener('click', toggleActiveClass)
            moreItemsButton.addEventListener('click', toggleActiveClass)
        }

        if (moreItemsButtonNBA) {
            moreItemsButtonNBA.removeEventListener('click', toggleActiveClass)
            moreItemsButtonNBA.addEventListener('click', toggleActiveClass)
        }
    }
}

function toggleActiveClass() {
    this.classList.toggle('is-active')
}

// Hightlight active sub menu under .more container
export const highlightSubNavHandler = () => {
    const isNbaSibPage = document.querySelectorAll('.primary-menu-wrapper .nba-menu-wrapper .branded-secondary-nav-buttons').length > 0
    const menuBottom = document.querySelector('.tsn-primary-menu__bottom')
    const activeSubMenu = document.querySelector(
        '.primary-menu-wrapper > .menu > .more > .more-submenu > .menu-item--active-trail'
    )
    const activeItemsSubMenu = document.querySelector(
        '.primary-menu-wrapper > .menu > .more > .more-submenu > .menu-item--active-trail > .menu'
    )

    const handleSubNav = () => {
        if (isDesktop()) {
            menuItemColumnHandler()

            if (activeSubMenu && activeItemsSubMenu) {
                menuBottom.append(activeItemsSubMenu.cloneNode(true))
                const menuBottomItems = document.querySelectorAll('.tsn-primary-menu__bottom > .menu > .menu-item')

                primaryMenuBottomHandler(menuBottomItems)
            }
            const menuTopItems = document.querySelectorAll(
                '.tsn-primary-menu__top > .tsn-primary-menu__container .primary-menu-wrapper > .menu > .menu-item--active-trail .menu > .menu-item'
            )

            if (menuTopItems.length !== 0) {
                primaryMenuBottomHandler(menuTopItems)
            }
        } else {
            const menuBottomItems = document.querySelectorAll('.tsn-primary-menu__bottom > .menu > .menu-item')
            if (menuBottomItems.length !== 0) {
                primaryMenuBottomHandler(menuBottomItems)
            }
        }
    }

    if (isNbaSibPage) {
        waitForElmBySelectorIndex('.primary-menu-wrapper .menu-item--active-trail .nba-menu-wrapper .nba-menu-inner > .menu', 0).then(() => {
            handleSubNav()
        })
    } else {
        handleSubNav()
    }
}

// Handles more items container DOM
const moreItemsContainer = () => {
    const moreItemList = document.createElement('li')
    moreItemList.classList.add('menu-item', 'more')

    const anchorChild = document.createElement('a')
    anchorChild.innerHTML = '...'

    const unorderListChild = document.createElement('ul')
    unorderListChild.classList.add('more-submenu')

    moreItemList.append(anchorChild, unorderListChild)

    return moreItemList
}

// Handles .more container number of columns
const menuItemColumnHandler = () => {
    const numberOfMoreItems = document.querySelectorAll(
        '.primary-menu-wrapper > .menu > .more > .more-submenu > .menu-item'
    ).length
    const moreItemsSubMenu = document.querySelector('.primary-menu-wrapper > .menu > .more > .more-submenu')

    if (numberOfMoreItems > 9 && numberOfMoreItems <= 18) {
        moreItemsSubMenu.classList.add('two-columns')
    }

    if (numberOfMoreItems > 18 && numberOfMoreItems <= 27) {
        moreItemsSubMenu.classList.add('three-columns')
    }

    if (numberOfMoreItems > 27 && numberOfMoreItems <= 36) {
        moreItemsSubMenu.classList.add('four-columns')
    }
}

// Highlight sub menu on bottom container
const primaryMenuBottomHandler = (subMenu) => {
    const landingDraftPage = document.querySelector('.drafts-landing-page')
    const mockDraftPage = document.querySelector('.mock-draft-page')
    const roundByRoundPage = document.querySelector('.drafts-round-by-round-page')
    const teamByTeamPage = document.querySelector('.drafts-team-by-team-page')
    const articlePage = document.querySelector('.article-page')
    const urlHref = window.location.href

    if (articlePage) {
        let count = 0

        const compareAnchorHref = (url, anchorHref) => {
            if (anchorHref !== '') {
                let parsedUrl = new URL(url);
                let [, firstUrlPathname, , ...remainingUrlPathnames] = parsedUrl.pathname.split('/');
                let urlWithoutSecondPathname = `/${[firstUrlPathname, ...remainingUrlPathnames].join('/')}`;

                let parsedAnchorHref = new URL(anchorHref);
                let [, firstAnchorPathname, , ...remainingAnchorPathnames] = parsedAnchorHref.pathname.split('/');
                let anchorHrefWithoutSecondPathname = `/${[firstAnchorPathname, ...remainingAnchorPathnames].join('/')}`;
                return urlWithoutSecondPathname === anchorHrefWithoutSecondPathname;
            }
        }

        for (const menuTopItem of subMenu) {
            const anchorTag = menuTopItem.querySelector('a')

            if (isTemplateEnv() && anchorTag.href === urlHref) {
                count++
            } else {
                const isHrefEqual = compareAnchorHref(urlHref, anchorTag.href);
                if (isHrefEqual) {
                    count++
                }
            }
        }

        if (count > 0) {
            for (const menuTopItem of subMenu) {
                const anchorTag = menuTopItem.querySelector('a')
                if (isTemplateEnv() && anchorTag.href === urlHref) {
                    menuTopItem.classList.add('menu-item--active-trail')
                } else {
                    const isHrefEqual = compareAnchorHref(urlHref, anchorTag.href);
                    if (isHrefEqual) {
                        menuTopItem.classList.add('menu-item--active-trail')
                    }
                }
            }
        }

        if (count === 0) {
            for (const menuTopItem of subMenu) {
                const anchorTag = menuTopItem.querySelector('a')
                if (menuTopItem.textContent.includes('News') && anchorTag.href.includes('news')) {
                    menuTopItem.classList.add('menu-item--active-trail')
                }
            }
        }
    } else if (landingDraftPage || mockDraftPage || roundByRoundPage || teamByTeamPage) {
        for (const menuTopItem of subMenu) {
            const anchorTag = menuTopItem.querySelector('a')
            if (menuTopItem.textContent.includes('Draft') && anchorTag.href.includes('draft')) {
                menuTopItem.classList.add('menu-item--active-trail')
            }
        }
    } else {
        for (const menuTopItem of subMenu) {
            const anchorTag = menuTopItem.querySelector('a')
            if (url.href === anchorTag.href) {
                menuTopItem.classList.add('menu-item--active-trail')
            }
        }
    }
}

// Hide primary menu bottom
export const hidePrimaryMenuBottomHandler = () => {
    const primaryMenuBottom = document.querySelector('.tsn-primary-menu__bottom')
    const primaryMenuSubMenu = document.querySelector(
        '.primary-menu-wrapper > .menu > .menu-item--active-trail > .menu'
    )
    const additionalMenuSubMenu = document.querySelector(
        '.additional-menu-wrapper > .additional-header--menu > .menu-item--active-trail > .menu'
    )
    const nbaMenuSubMenu = document.querySelector(
        '.primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper'
    )

    if (primaryMenuBottom.children === 0 || primaryMenuSubMenu || additionalMenuSubMenu || nbaMenuSubMenu) {
        return
    }

    primaryMenuBottom.classList.add('secondary-empty')
}

const childrenArrowContainer = () => {
    const listContainer = document.createElement('i')
    listContainer.classList.add('has-children__arrow')

    return listContainer
}

const childrenSecondArrowContainer = () => {
    const listContainer = document.createElement('i')
    listContainer.classList.add('has-children-second__arrow')

    return listContainer
}
